<template>
    <div style="width: 400px; margin: 0 auto">
        <barchart :options="chart_options" :chart-data="getData()"></barchart>
    </div>
</template>

<script>
import Barchart from "./Barchart";

export default {
    name: "location_chart",
    components: { Barchart },
    props: ["data"],
    mounted() {},
    data() {
        return {
            info: this.data,
            chart_options: {
                maintainAspectRatio: true,
                responsive: true,
                scale: {
                    ticks: {
                        min: 40,
                        max: 100,
                    },
                },
                legend: {
                    position: "right",
                },
            },
        };
    },
    methods: {
        getData() {
            let hubs = [];
            let values = [];
            let colors = [];
            this.info.potencias.map(function (value, key) {
                hubs.push(value.hub.etiqueta);
                values.push(value.potencia);
            });
            return {
                labels: hubs,
                datasets: [
                    {
                        data: values,
                        backgroundColor: [
                            "rgba(14, 75, 239, 0.5)",
                            "rgba(191, 185, 92, 0.5)",
                            "rgba(252, 147, 3, 0.5)",
                            "rgba(244, 0, 161, 0.5)",
                        ],
                    },
                ],
            };
        },
    },
};
</script>